import React from "react";
import { useAnnualSecurityReportDownloader } from "../../../../data/reports/securityCommission/securityAnnual/hooks/useSecurityReportDownloader";
import { useAnnualSecurityExcelDownloader } from "../../../../data/reports/securityCommission/securityAnnual/hooks/useAnnualSecurityExcelDownloader";
import DownloadIcon from "@material-ui/icons/CloudDownloadOutlined";
import ExcelIcon from "@material-ui/icons/TableChartOutlined";
import { IconButton } from "@material-ui/core";
import { CustomTooltip } from "../../../components/common/CustomTooltip";

export const DownloadButton: React.FunctionComponent = () => {
	const [downloader, fetchState] = useAnnualSecurityReportDownloader();
	return (
		<CustomTooltip titleKeyword="exportPDFTooltip">
			<IconButton
				color="secondary"
				component="span"
				onClick={downloader}
				disabled={fetchState.type !== "not-started"}
			>
				<DownloadIcon />
			</IconButton>
		</CustomTooltip>
	);
};


export const DownloadExcelButton: React.FunctionComponent = () => {
	const [downloader, fetchState] = useAnnualSecurityExcelDownloader();
	return (
	  <CustomTooltip titleKeyword="exportXLSXTooltip">
		<IconButton
		  color="secondary"
		  component="span"
		  onClick={downloader}
		  disabled={fetchState.type !== "not-started"}
		>
		  <ExcelIcon />
		</IconButton>
	  </CustomTooltip>
	);
  };
  